import { Longhand } from "../longhand.js";
import Base from "./border-top-style.js";
/**
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/border-right-style}
 * @internal
 */
export default Longhand.extend(Base);
//# sourceMappingURL=border-right-style.js.map